// extracted by mini-css-extract-plugin
export var chip = "_b5-0";
export var filterDropdown = "_b5-5";
export var filterItem = "_b5-6";
export var icon = "_b5-1";
export var removeButton = "_b5-3";
export var removeIcon = "_b5-4";
export var separator = "_b5-2";